import Link from 'next/link'
import { FC, useEffect } from 'react'

import Card from 'components/base/Card'
import WhatsAppPrice from 'components/WhatsAppPrice'
import classNames from 'classnames'
import trackIntent from 'common/trackIntent'

interface Props {
  className?: string
}

const WhatsAppBusinessCard: FC<Props> = ({ className }) => {
  useEffect(() => {
    void trackIntent('WHATSAPP_BUSINESS_CARD_VIEW')
  }, [])

  return (
    <Link
      href='/whatsapp-business'
      className={classNames(className, 'text-body')}
    >
      <Card padding={'none'}>
        <div style={{ height: '100%', minHeight: 300 }} className='flex-row'>
          <div className='col-6 d-flex flex-column    ps-5 pt-6'>
            <div className='flex-1'>
              <h3 className='fw-bold mb-1'>
                Personalised WhatsApp Business Phone Number
              </h3>
              <div
                style={{ marginRight: '-5%' }}
                className='mb-4 fw-semibold fs-lg'
              >
                Connect with your customers directly, immediately and more
                effectively with our WhatsApp for Business number service.
              </div>
            </div>
            <div className='mb-4'>
              <WhatsAppPrice />
            </div>
          </div>
          <div className='col-6 position-relative  d-flex justify-content-center align-items-center'>
            <img
              src='/images/whatsapp/hero.png'
              alt='WhatsApp Business mascot'
              className='position-absolute bottom-0 end-0 hero-image'
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
              }}
            />
          </div>
        </div>
      </Card>
    </Link>
  )
}

export default WhatsAppBusinessCard
